import script from "./TheDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./TheDrawer.vue?vue&type=script&setup=true&lang=js"

import "./TheDrawer.vue?vue&type=style&index=0&id=616b112b&lang=stylus"

const __exports__ = script;

export default __exports__